// extracted by mini-css-extract-plugin
export default {"content":"date-criteria_content__s3EMT","operators":"date-criteria_operators__-kbUZ"};